import { render, staticRenderFns } from "./OrderInstructionDetail.vue?vue&type=template&id=3a05635c&scoped=true&"
import script from "./OrderInstructionDetail.vue?vue&type=script&lang=ts&"
export * from "./OrderInstructionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./OrderInstructionDetail.vue?vue&type=style&index=0&id=3a05635c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05635c",
  null
  
)

export default component.exports